import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import api, {standardApiSlice} from 'service/api'

export const logout = createAsyncThunk('login/logout', api.post('/logout'))

export const logoutSlice = createSlice(standardApiSlice('logout', logout))

// export const { logout } = loginSlice.actions

export default logoutSlice.reducer